import React from 'react';

interface PrimaryButtonProps {
  text: string;
  containerStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  disabled?: boolean;
  onClick: (() => void) | ((event: any) => void);
  invertedColors?: boolean;
  resetColors?: boolean;
  type?: 'submit' | 'reset' | 'button' | undefined;
  className?: string;
}

const PrimaryButtonV2: React.FC<PrimaryButtonProps> = ({
  text,
  containerStyle,
  buttonStyle,
  disabled,
  onClick,
  invertedColors,
  resetColors,
  type,
  className,
}: PrimaryButtonProps) => {
  const styles = {
    container: {
      display: 'flex',
      alignItem: 'center',
      justifyContent: 'center',
    },
    button: {
      cursor: 'pointer',
      backgroundColor: !resetColors ? (invertedColors ? '#fff' : '#0B1B5C') : '#D1D1D3',
      padding: '10px 15px',
      border: invertedColors ? '1px solid #0B1B5C' : 'none',
      minWidth: 150,
      height: 'auto',
      borderRadius: 10,
      boxShadow: invertedColors ? '1px 17px 44px rgba(3, 2, 41, 0.07)' : '',
      color: invertedColors ? '#0B1B5C' : '#fff',
      fontWeight: 500,
      fontSize: 15,
    } as React.CSSProperties,
    buttonDisabled: {
      backgroundColor: '#ededed',
      padding: '10px 15px',
      border: 0,
      minWidth: 150,
      height: 'auto',
      borderRadius: 10,
    },
  };

  return (
    <div style={{ ...styles.container, ...containerStyle }}>
      <button
        {...(className ? { className } : {})}
        style={{ ...(disabled ? styles.buttonDisabled : styles.button), ...buttonStyle }}
        disabled={disabled}
        onClick={onClick}
        type={type}
      >
        {text}
      </button>
    </div>
  );
};

export default PrimaryButtonV2;
